@if (navItems$ | async; as navItems) {
  <app-nav [navItems]="navItems" />

  <div class="container">
    <div class="item">
      <app-item-preview />
      <app-purchase-image />
    </div>

    <div>
      <app-item-info />
      <app-item-tags />
      <app-item-gallery />
    </div>
  </div>
}
